import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styles from './ProfileBreadcrumbs.module.scss'

// breadcrumbs
// Items link via `to` (router navigation), `href` (full page load), or
// render as plain text when neither is set.
export default function ProfileBreadcrumbs({ items, rightContent }) {
  const { t } = useTranslation()

  return (
    <nav className={styles.wrapper} aria-label="Breadcrumb">
      <div className={styles.inner}>
        <ol className={styles.breadcrumbs}>
          {Array.isArray(items) && items.length > 0 ? (
            items.map((item, i) => {
              const ariaCurrent = i === items.length - 1 ? 'page' : undefined
              return (
                <li key={i} className={styles.item}>
                  {item.to ? (
                    <Link
                      to={item.to}
                      className={styles.link}
                      aria-current={ariaCurrent}
                    >
                      {item.label}
                    </Link>
                  ) : item.href ? (
                    <a
                      href={item.href}
                      className={styles.link}
                      aria-current={ariaCurrent}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <span className={styles.current} aria-current={ariaCurrent}>
                      {item.label}
                    </span>
                  )}
                  {i < items.length - 1 && (
                    <span className={styles.sep}> &gt; </span>
                  )}
                </li>
              )
            })
          ) : (
            <li className={styles.item}>
              <span className={styles.current}>
                {t('profiles.youAreHere', 'You are here')}:{' '}
                {t('profiles.profile', 'Profile')}
              </span>
            </li>
          )}
        </ol>
        {rightContent && <div className={styles.right}>{rightContent}</div>}
      </div>
    </nav>
  )
}

ProfileBreadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      href: PropTypes.string,
      to: PropTypes.string,
    }),
  ),
  rightContent: PropTypes.node,
}
